<template>
  <section
    v-if="parsedDictionary && parsedDictionary.length > 0"
    class="grid mb-component w-full px-12 grid-cols-1 lg:grid-cols-3"
  >
    <div
      v-for="(advantage, index) in parsedDictionary"
      :key="index"
      class="p-8 border-y border-r border-border"
      :class="{
        'border-l': index !== parsedDictionary.length - 1,
        'max-lg:border-l': index === parsedDictionary.length - 1,
      }"
    >
      <h3 class="font-medium text-40 tracking-tightest2 text-darkGreen">
        {{ advantage.heading }}
      </h3>
      <p
        class="text-darkGreen font-medium text-18 leading-140 tracking-tightest2 mt-2"
      >
        {{ advantage.subheading }}
      </p>
      <p
        class="text-graphite-6 text-14 mt-4 -tracking-0.5 leading-145 font-normal"
      >
        {{ advantage.description }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Advantages",

  data() {
    return {
      parsedDictionary: {},
    };
  },

  props: {
    dictionary: {
      type: String,
      required: true,
    },
  },

  created() {
    this.parsedDictionary = JSON.parse(this.dictionary);
  },
};
</script>
